import { Checkbox } from "antd";
import React from "react";
import styles from "./CreditSortModal.module.css";
import { sort_list } from "../Credit";
import Button from "../../../../components/ui/Button";

const CreditSortModal = (props) => {
  const { set_sort_visible, sort_value, set_sort_value, submit_filter } = props;

  const submit = () => {
    submit_filter();
    set_sort_visible(false);
  };

  const checkbox_change = (value) => {
    if (value !== sort_value) {
      set_sort_value(value);
    } else {
      set_sort_value(null);
    }
  };

  return (
    <>
      <div className={styles.Checkboxes}>
        <div
          style={{
            width: "100%",
            borderBottom: "0.5px solid var(--hig-color-black-3)",
            opacity: 0.5,
            height: "0",
            marginBottom: 8,
          }}
        />
        {sort_list.map((item) => {
          return (
            <Checkbox
              style={{ marginTop: "8px" }}
              checked={sort_value === item.value}
              className={styles.CheckboxStyle}
              onChange={(e) => {
                checkbox_change(item.value);
              }}
            >
              {item.label}
            </Checkbox>
          );
        })}
      </div>
      {/* <div className={styles.Seprator} /> */}
      <div className="w-full flex justify-center items-center">
        <Button
          onClick={submit}
          style_width="100%"
          style={{ maxWidth: 220 }}
          style_marginBottom={"8px"}
          style_marginTop={16}
        >
          Ok
        </Button>
      </div>
    </>
  );
};

export default CreditSortModal;
